<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">Change {{ user.verbose_name }} password</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="password1">
                    <div class="gcmcn-form-label">New password</div>
                    <el-input
                        size="mini"
                        type="password"
                        v-model="form.password1"
                    ></el-input>
                </el-form-item>
                <el-form-item class="gcmcn-form-input" prop="password2">
                    <div class="gcmcn-form-label">Confirm password</div>
                    <el-input
                        size="mini"
                        type="password"
                        v-model="form.password2"
                    ></el-input>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import HttpErrorManager from 'fundation-app-vuejs/src/components/partials/http-error-manager.js';
export default {

    components: {
    },

    props: {
        user: {
            required: true,
            type: Object,
        },
        entityUid:{
            type: String,
            required: false,
            default: '',
        },
        isEntityRelated:{
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data (){
        return {
            form: {
                password1: '',
                password2: '',
                email: '',
            },
            loading: false,
        };
    },

    computed: {
        rules () {
            return {
                password1: [{ required: true }],
                password2: [{ required: true }],
            };
        },

    },
    mounted() {
        this.httpErrorManager = new HttpErrorManager(this.currentLang);
    },
    methods: {
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    this.form.email = this.user.email;
                    if(this.isEntityRelated){
                        this.$store.dispatch('createItem', {
                            item:{
                                action: 'EDIT',
                                email: this.form.email,
                                password1: this.form.password1,
                                password2: this.form.password2,
                                status: 'PENDING',
                            },
                            scopes: {'X-Entity-Uid': this.entityUid},
                            model: 'userManagementRequests',
                            url: this.$store.state.api.meta.listModels.userManagementRequests.url,
                        })
                        .then(async (res) => {
                            this.$store.dispatch('fundation/watchRequestStatus',{
                                url: res.url
                            }).then(() => {
                                this.$notify.success({
                                    title: 'Success',
                                    message: `Password was successfully updated`
                                });
                                this.loading = false;
                                this.$emit('on-user-updated', this.user);
                            }).catch(error => {
                                this.$message.error(error.data.verbose_status);
                                this.loading = false;
                            });
                        }).catch((e) => {
                            console.error(e);
                            this.$message.error(`Error while updating password`);
                            this.loading = false;
                        });
                    }else{
                        this.$store.dispatch('changeUserPassword', this.form).then(() => {
                            this.$message({
                                message: 'Password was successfully updated',
                                type: 'success'
                            });
                            this.loading = false;
                            this.$emit('on-user-updated', this.user);
                        }).catch((e) => {
                            console.error(e);
                            let error = this.httpErrorManager.getMessage(e.response.status, e.response.data._errors);
                            this.$message.error(error ? error : e.response.data.message);
                            this.loading = false;
                            this.$emit('leave-form-view');
                        });
                    }
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Takers/user-change-password.vue